import { config } from "/app.config"

const router = [
  {
    path: "analytics",
    name: "analytics",
    component: () => import("@/views/Analytics/Analytics"),
    meta: {
      pageTitle: "Account analytics",
      icon: "BarChart2Icon",
      rule: "owner",
    },
    children: [
      {
        name: "analytics.streaming",
        path: "streaming",
        component: () => import("@/views/Analytics/AnalyticsStreaming"),
        meta: {
          pageTitle: "Streaming analytics",
          parent: "analytics",
          icon: "PhoneIncomingIcon",
          rule: "owner",
        },
      },
      {
        name: "analytics.live",
        path: "live",
        component: () => import("@/views/Analytics/AnalyticsLive"),
        meta: {
          pageTitle: "Live analytics",
          parent: "analytics",
          icon: "ActivityIcon",
          rule: "owner",
        },
      },
      {
        name: "analytics.podcasts",
        path: "podcasts",
        component: () => import("@/views/Analytics/AnalyticsPodcasts"),
        meta: {
          pageTitle: "Podcasts analytics",
          parent: "analytics",
          icon: "MicIcon",
          rule: "owner",
        },
        children: [
          {
            name: "analytics.podcasts.overview",
            path: "overview",
            component: () => import("@/views/Analytics/AnalyticsPodcastsOverview"),
            meta: {
              pageTitle: "Podcasts analytics overview",
              parent: "analytics.podcasts",
              icon: "MicIcon",
              rule: "owner",
            },
          },
          {
            name: "analytics.podcasts.full",
            path: "full",
            component: () => import("@/views/Analytics/AnalyticsPodcastsFull"),
            meta: {
              pageTitle: "Podcasts analytics",
              parent: "analytics.podcasts",
              icon: "MicIcon",
              rule: "owner",
            },
          },
        ],
      },
      {
        name: "analytics.raw",
        path: "raw",
        component: () => import("@/views/Analytics/AnalyticsRaw"),
        meta: {
          pageTitle: "Podcasts raw",
          parent: "analytics",
          icon: "BarChartIcon",
          rule: "owner",
        },
      },
    ],
  },
]

if (config.isZeno) {
  router[0].children.push({
    name: "analytics.ctl",
    path: "ctl",
    component: () => import("@/views/Analytics/AnalyticsCTL"),
    meta: {
      pageTitle: "Call-in analytics",
      parent: "analytics",
      icon: "PhoneIncomingIcon",
      rule: "owner",
    },
  })

  router[0].children.push({
    name: "analytics.app",
    path: "app",
    component: () => import("@/views/Analytics/AnalyticsApp"),
    meta: {
      pageTitle: "App analytics",
      parent: "analytics",
      icon: "PhoneIncomingIcon",
      rule: "owner",
    },
  })
}

export default router
